import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Stack,
  TextInput,
  Button,
  FormField,
  Text,
  VIPSO_RED,
} from '@vipso/shared';
import { IconPhone } from '@tabler/icons-react';
import { setPendingOrgId, setPendingPhone } from '../store/authSlice';
import type { RootState } from '../store';
import { LoginLandingLayout, loginPrimaryButtonStyle } from '../features/auth/LoginLandingLayout';
import { DEMO_OTP } from '../mock/mockData';

export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useSelector((state: RootState) => state.auth.theme);
  const config = useSelector((state: RootState) => state.auth.config);
  const logoUrl = config?.logoUrl || theme?.logoUrl;

  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!phone.trim()) return;

    setLoading(true);
    try {
      dispatch(setPendingOrgId(null));
      dispatch(setPendingPhone(phone.trim()));
      navigate('/otp');
    } finally {
      setLoading(false);
    }
  }

  return (
    <LoginLandingLayout logoUrl={logoUrl}>
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          <Text size="sm" c="dimmed" ta="center">
            {t('auth.demoHint', { otp: DEMO_OTP })}
          </Text>

          <FormField label={t('common.phone')} required>
            <TextInput
              value={phone}
              onChange={(e) => setPhone(e.currentTarget.value)}
              placeholder={t('auth.phonePlaceholderDemo')}
              type="tel"
              inputMode="numeric"
              autoComplete="tel"
              leftSection={<IconPhone size={16} color={VIPSO_RED} />}
            />
          </FormField>

          <Button
            type="submit"
            loading={loading}
            fullWidth
            style={loginPrimaryButtonStyle}
          >
            {t('auth.sendOtp')}
          </Button>

          <Text size="sm" ta="center" c="dimmed">
            {t('auth.noAccount')}{' '}
            <Text component="span" c={VIPSO_RED}>
              {t('auth.register')}
            </Text>
          </Text>
        </Stack>
      </form>
    </LoginLandingLayout>
  );
}
